module.exports = __webpack_public_path__ + "static/media/mobile_logo@3x.db41c251.png";